import { useTranslations } from "next-intl";
import { useState } from "react";
import classNames from "classnames";
import { useGetProductsLiked } from "@hooks/use-current-user";
import {
  useCloseAddToUserListOffcanvas,
  useIsAddToUserListOffcanvasOpen,
  useAddProductToUserList,
} from "@hooks/use-userlists";
import Offcanvas from "@components/core/Offcanvas";
import UserListForm from "@components/core/UserListForm";
import CreateUserListCard from "@components/core/CreateUserListCard";
import { showErrorToast } from "@utils/toasts/showToasts";
import UserLists from "./UserLists";

function AddToUserListOffcanvas() {
  const t = useTranslations("common");

  const isAddToUserListOffcanvasOpen = useIsAddToUserListOffcanvasOpen();
  const closeAddToUserListOffcanvas = useCloseAddToUserListOffcanvas();
  const addProductToUserList = useAddProductToUserList();
  const getProductsLiked = useGetProductsLiked();

  const [step, setStep] = useState("chooseList");

  function displayChooseUserList() {
    setStep("chooseList");
  }

  function displayCreateUserListForm() {
    setStep("createList");
  }

  function closeOffcanvas() {
    closeAddToUserListOffcanvas();
    setStep("chooseList");
  }

  async function addProductToUserListAndClose(userList) {
    try {
      await addProductToUserList(userList.uuid);

      setStep("chooseList");
    } catch (err) {
      if (err.response?.data?.errors?.includes("list_not_found")) {
        showErrorToast(
          t("userlist.errors.add_product.list_not_found.title"),
          t("userlist.errors.add_product.list_not_found.subtitle"),
        );
      } else {
        showErrorToast(
          t("userlist.errors.unknown.title"),
          t("userlist.errors.unknown.subtitle"),
        );
        getProductsLiked();
      }
    }
  }

  return (
    <Offcanvas
      show={isAddToUserListOffcanvasOpen}
      onHide={closeOffcanvas}
      placement="bottom"
      title={t("userlist.my_lists")}
      size="lg"
      goBackButton={step === "createList"}
      onGoBack={displayChooseUserList}
    >
      <div className="add-product-to-userlist-offcanvas">
        <div
          className={classNames(
            "add-product-to-userlist-offcanvas-step userlists-step",
            step === "chooseList" && "show",
          )}
        >
          <div className="add-product-to-userlist-offcanvas-content">
            <h3 className="mb-4 pb-2 text-center">{t("userlist.choose_list")}</h3>

            <div className="pb-5">
              <CreateUserListCard
                onClick={displayCreateUserListForm}
                className="mb-2 with-hover-effect"
                trackingName="CreateUserlistFromOffcanvas"
              />

              <UserLists onUserListClick={addProductToUserListAndClose} />
            </div>
          </div>
        </div>

        <div
          className={classNames(
            "add-product-to-userlist-offcanvas-step create-userlist-step",
            step === "createList" && "show",
          )}
        >
          <div className="add-product-to-userlist-offcanvas-content">
            <UserListForm
              onAfterSubmit={addProductToUserListAndClose}
              visible={step === "createList"}
            />
          </div>
        </div>
      </div>
    </Offcanvas>
  );
}

export default AddToUserListOffcanvas;
